export interface InitState {
  isShowPlayDetail: boolean
}

export const playDetailState: InitState = {
  isShowPlayDetail: false,
}
